import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnMU: CultureInfo = {
  name: 'en-MU',
  displayName: 'English (Mauritius)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-MU',
  parent: CultureInfoEn
};
